import React from  'react';
export default function Header(props){
    return (
        <h1>SIMPLE REACT  {props.title}!</h1>
    );
}
